export default "__VITE_ASSET__B7h3ERKv__"